import React, { useMemo } from 'react';

import { ExternalLink } from 'features/order-tracker/shared-components';

import { HELPING_MESSAGE, anonymousLinkList, authLinkList } from './constants';

import styles from './styles.module.scss';

export const BillingInfo: React.FC<components.BillingInfo> = ({ isAuthenticated }) => {
  const linksList = useMemo(() => (isAuthenticated ? authLinkList : anonymousLinkList), [isAuthenticated]);
  const linkTarget = isAuthenticated ? '_blank' : '_self';

  return (
    <div className={styles.contentHolder}>
      <p className={styles.helpMessage}>{HELPING_MESSAGE}</p>
      {linksList.map((item) => (
        <div key={item[0].label + item[1].label} className={styles.row}>
          <ExternalLink
            text={item[0].label}
            link={item[0].link}
            target={linkTarget}
            analytics={item[0].label}
            className={styles.externalLink}
            iconClassName={styles.arrowIcon}
          />
          <ExternalLink
            text={item[1].label}
            link={item[1].link}
            target={linkTarget}
            analytics={item[1].label}
            className={styles.externalLink}
            iconClassName={styles.arrowIcon}
          />
        </div>
      ))}
    </div>
  );
};
